import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { SystemState } from '../types';

class System {
  systemState: SystemState = {
    startDateTime: '',
    endDateTime: '',
    reason: '',
    isNecessaryToBlock: false,
    isNecessaryToShowMessage: false,
  };
  isShowDefaultBanner = false;
  isShowModal: boolean | null = null;


  constructor() {
    makeAutoObservable(this);
  }

  fetchSystemState = async () => {
    const systemStateResponse = await apiConfig.systemStateService.getSystemState();
    localStorage.setItem('isNecessaryToBlock', JSON.stringify(this.systemState.isNecessaryToBlock));
    localStorage.setItem('isNecessaryToShowMessage', JSON.stringify(this.systemState.isNecessaryToShowMessage));
    if (!systemStateResponse) {
      this.isShowDefaultBanner = true;
      this.systemState.isNecessaryToBlock = true;
      return;
    }
    this.isShowDefaultBanner = false;
    this.systemState = systemStateResponse;
  };

  setShowNewsModalRequest = async (bool?: boolean) => {
    try {
      await apiConfig.systemStateService.setShowNewsModal(bool);
    } catch (error) {
      throw Error('error');
    }
  };
  checkActualityNewsModal = async () => {
    try {
      this.isShowModal = await apiConfig.systemStateService.checkActualityNewsModal();
    } catch (error) {
      throw Error('error');
    }
  };
}

export const SystemStore = new System();